import { z } from 'zod';
import { defineEndpoint } from '../define';

/**
 * Connection status only — booleans derived from server-side env credentials.
 * Credential values themselves are never exposed through any endpoint.
 */
export const ReleaseIntegrationsStatusSchema = z.object({
  github: z.boolean(),
  clickup: z.boolean(),
  linear: z.boolean(),
  appStoreConnect: z.boolean(),
  slack: z.boolean(),
});
export type ReleaseIntegrationsStatus = z.infer<typeof ReleaseIntegrationsStatusSchema>;

export const getReleaseIntegrationsStatus = defineEndpoint({
  method: 'GET',
  path: '/v1/release-integrations',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: ReleaseIntegrationsStatusSchema }),
});
